import {restHelperService} from "./rest-helper.service";

export const messageService = {
    getChat,
    sendMessage
};

function getChat(nosender=false, time="") {
    let request = {}
    if(nosender) {
        request["no_sender"] = "true"
    }
    if(time !== "") {
        request["time"] = time
    }
    return restHelperService.createGetRequest("/rest/data/chat",request)
        .then(res => {
            let response = restHelperService.getResponse(res);
            return Promise.resolve(response);
        }).catch((res) => {
            return restHelperService.handleCatch(res)
        })
}

function sendMessage(message, to, isgroup) {
    let request = {
        group: isgroup,
        receiver: to,
        message: message
    }
    return restHelperService.createPostRequest("/rest/data/chat",request)
        .then(res => {
            let response = restHelperService.getResponse(res);
            return Promise.resolve(response);
        }).catch((res) => {
            return restHelperService.handleCatch(res)
        })
}